import { StatusPill } from '../ui/StatusPill';
import {
  admissionCheckLabel,
  admissionCheckTone,
  admissionReadinessLabel,
  admissionReadinessTone,
} from '../../admission/labels';
import { ADMISSION_READINESS } from '../../admission/labels';

function StatusGlyph({ tone, spinning }) {
  const className =
    tone === 'danger'
      ? 'text-rose-600'
      : tone === 'warning'
        ? 'text-amber-600'
        : tone === 'success'
          ? 'text-emerald-600'
          : 'text-sky-600';
  if (spinning) {
    return (
      <span
        className={`inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-t-transparent ${className}`}
        aria-hidden
      />
    );
  }
  return (
    <span className={`inline-flex h-3.5 w-3.5 items-center justify-center ${className}`} aria-hidden>
      <span className="h-2 w-2 rounded-full bg-current" />
    </span>
  );
}

export function AdmissionStatus({
  status,
  kind = 'readiness',
  className = '',
}) {
  const label =
    kind === 'check' ? admissionCheckLabel(status) : admissionReadinessLabel(status);
  const tone =
    kind === 'check' ? admissionCheckTone(status) : admissionReadinessTone(status);
  const spinning = status === ADMISSION_READINESS.EVALUATING;
  return (
    <span
      className={`inline-flex items-center gap-1.5 ${className}`.trim()}
      aria-label={label}
    >
      <StatusGlyph tone={tone} spinning={spinning} />
      <StatusPill value={status} tone={tone} label={label} />
    </span>
  );
}
